<template>
  <AppShell
    v-model:current-lang="currentLang"
    variante="produto"
    evitar-banner-mobile
    @lang-change="onLangChange"
  >
    <PageHero
      :logo-src="logoBranco"
      logo-alt="OligoCheck"
      :badge="t.heroBadge"
      badge-variante="erro"
      :subtitulo="t.heroSubtitulo"
    >
      <template #titulo>
        <span class="titulo-resto">{{ t.heroTituloAntes + ' ' }}</span
        ><span class="ds-texto-gradiente">{{ t.heroTituloDestaque }}</span>
      </template>

      <template #ctas>
        <!-- Marca visual 404: número gigante em gradiente -->
        <div class="erro-numero" aria-hidden="true">
          <span class="erro-numero-digito">4</span>
          <span class="erro-numero-zero">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="none">
              <circle cx="50" cy="50" r="42" stroke="url(#gradErro)" stroke-width="10" />
              <defs>
                <linearGradient id="gradErro" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stop-color="#14cbf0" />
                  <stop offset="100%" stop-color="#1aaf95" />
                </linearGradient>
              </defs>
            </svg>
          </span>
          <span class="erro-numero-digito">4</span>
        </div>

        <p class="caminhos-pergunta">{{ t.linksPergunta }}</p>

        <div class="caminhos-grid">
          <!-- Página principal -->
          <a
            href="/"
            @click.prevent="irPara('/')"
            class="caminho-card caminho-home"
          >
            <div class="caminho-icone icone-home">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 9.5 12 2l9 7.5V21a1 1 0 0 1-1 1h-5v-7h-6v7H4a1 1 0 0 1-1-1V9.5z"/>
              </svg>
            </div>
            <div class="caminho-conteudo">
              <span class="caminho-label">{{ t.homeLabel }}</span>
              <strong class="caminho-titulo">{{ t.homeTitulo }}</strong>
              <span class="caminho-desc">{{ t.homeDesc }}</span>
            </div>
            <div class="caminho-seta">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
            </div>
          </a>

          <!-- WhatsApp consultor -->
          <a
            :href="whatsappUrl"
            target="_blank"
            rel="noopener"
            class="caminho-card caminho-wpp"
          >
            <div class="caminho-icone icone-wpp">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
              </svg>
            </div>
            <div class="caminho-conteudo">
              <span class="caminho-label">{{ t.wppLabel }}</span>
              <strong class="caminho-titulo">{{ t.wppTitulo }}</strong>
              <span class="caminho-desc">{{ t.wppDesc }}</span>
            </div>
            <div class="caminho-seta">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
            </div>
          </a>
        </div>

        <!-- Código técnico do erro (sutil, para quem procura) -->
        <p class="erro-tecnico" aria-label="HTTP 404">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          <span>{{ t.codigoTecnico }}</span>
        </p>
      </template>
    </PageHero>

    <template #rodape>
      <RodapeSite marca="OligoCheck" />
    </template>
  </AppShell>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import AppShell from '@/components/global/layout/AppShell.vue'
import PageHero from '@/components/global/layout/PageHero.vue'
import RodapeSite from '@/components/global/layout/RodapeSite.vue'
import logoBranco from '@/assets/images/logo-branco.svg'
import { useSeo } from '@/composables/useSeo'

const currentLang = ref('es')
const router = useRouter()

const onLangChange = () => {
  /* AppShell já controla a escolha manual internamente. */
}

const irPara = (path) => {
  router.push(path)
}

/* ============================================================
   WhatsApp de vendas — mesmo usado nas demais páginas.
   Mensagem contextualizada: indica que a pessoa chegou pela 404.
   ============================================================ */
const whatsappFone = '34617488404'
const whatsappUrl = computed(() => {
  const msgs = {
    es: 'Hola! Me gustaría tener más información sobre el OligoCheck.',
    pt: 'Olá! Gostaria de ter mais informações sobre o OligoCheck.',
    en: "Hi! I'd like to get more information about OligoCheck."
  }
  const msg = encodeURIComponent(msgs[currentLang.value])
  return `https://api.whatsapp.com/send/?phone=${whatsappFone}&text=${msg}`
})

/* ============================================================
   i18n — textos por idioma
   ============================================================ */
const translations = {
  es: {
    heroBadge: '404 · Página no encontrada',
    heroTituloAntes: 'Esta página',
    heroTituloDestaque: 'no existe',
    heroSubtitulo:
      'Pero tranquilo — por aquí dentro tienes todo lo que necesitas saber sobre OligoCheck. Elige abajo por dónde seguir.',
    linksPergunta: '¿A dónde quieres ir?',
    homeLabel: 'Página principal',
    homeTitulo: 'Volver al inicio',
    homeDesc: 'Explora todos los enlaces oficiales de OligoCheck.',
    wppLabel: 'Habla con un consultor',
    wppTitulo: 'Contactar por WhatsApp',
    wppDesc: 'Respondemos tus dudas en tiempo real, sin compromiso.',
    codigoTecnico: 'Error 404 · Recurso no encontrado en portal.oligocheck.es'
  },
  pt: {
    heroBadge: '404 · Página não encontrada',
    heroTituloAntes: 'Essa página',
    heroTituloDestaque: 'não existe',
    heroSubtitulo:
      'Mas fica tranquilo — por aqui dentro você encontra tudo o que precisa saber sobre o OligoCheck. Escolha abaixo por onde continuar.',
    linksPergunta: 'Para onde você quer ir?',
    homeLabel: 'Página principal',
    homeTitulo: 'Voltar ao início',
    homeDesc: 'Explore todos os links oficiais do OligoCheck.',
    wppLabel: 'Fale com um consultor',
    wppTitulo: 'Contato por WhatsApp',
    wppDesc: 'Tiramos suas dúvidas em tempo real, sem compromisso.',
    codigoTecnico: 'Erro 404 · Recurso não encontrado em portal.oligocheck.es'
  },
  en: {
    heroBadge: '404 · Page not found',
    heroTituloAntes: "This page",
    heroTituloDestaque: "doesn't exist",
    heroSubtitulo:
      "But relax — inside this site you'll find everything you need to know about OligoCheck. Pick a destination below.",
    linksPergunta: 'Where do you want to go?',
    homeLabel: 'Main page',
    homeTitulo: 'Back to home',
    homeDesc: 'Explore all the official OligoCheck links.',
    wppLabel: 'Talk to a consultant',
    wppTitulo: 'Contact via WhatsApp',
    wppDesc: "We'll answer your questions in real time, no strings attached.",
    codigoTecnico: 'Error 404 · Resource not found on portal.oligocheck.es'
  }
}

const t = computed(() => translations[currentLang.value])

/* ============================================================
   SEO — página 404 NÃO deve indexar.
   robots: 'noindex, follow' impede indexação mas permite seguir
   os links internos para que o Google encontre os destinos válidos.
   ============================================================ */
const SITE_URL = 'https://portal.oligocheck.es'
const OG_IMAGE =
  'https://socheck.nyc3.cdn.digitaloceanspaces.com/6dce6cd1afe525bd7b8999-logo%20(1).svg'

useSeo(() => {
  const lang = currentLang.value
  const seo = translations[lang] || translations.es

  return {
    lang,
    title: `${seo.heroBadge} | OligoCheck`,
    description: seo.heroSubtitulo,
    robots: 'noindex, follow',
    canonical: `${SITE_URL}/erro`,
    image: OG_IMAGE,
    imageAlt: 'OligoCheck',
    type: 'website'
  }
})
</script>

<style scoped>
/* ============================================================
   TÍTULO — texto antes do gradiente
   ============================================================ */
.titulo-resto { color: var(--ds-text); }

/* ============================================================
   NÚMERO 404 — bloco visual gigante
   ============================================================ */
.erro-numero {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(8px, 2vw, 24px);
  margin: 0 auto var(--ds-s-7);
  user-select: none;
}

.erro-numero-digito {
  font-family: var(--ds-font-bold);
  font-size: clamp(96px, 22vw, 200px);
  line-height: 1;
  letter-spacing: -0.04em;
  background: linear-gradient(135deg, #14cbf0 0%, #1aaf95 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  text-shadow: 0 0 60px rgba(20, 203, 240, 0.2);
}

.erro-numero-zero {
  width: clamp(88px, 20vw, 180px);
  height: clamp(88px, 20vw, 180px);
  display: flex;
  align-items: center;
  justify-content: center;
  filter: drop-shadow(0 0 40px rgba(20, 203, 240, 0.35));
  animation: errorPulse 3s ease-in-out infinite;
}

.erro-numero-zero svg {
  width: 100%;
  height: 100%;
}

@keyframes errorPulse {
  0%, 100% {
    transform: scale(1);
    filter: drop-shadow(0 0 40px rgba(20, 203, 240, 0.35));
  }
  50% {
    transform: scale(1.04);
    filter: drop-shadow(0 0 60px rgba(26, 175, 149, 0.45));
  }
}

/* ============================================================
   LABEL ACIMA DO GRID
   ============================================================ */
.caminhos-pergunta {
  font-family: var(--ds-font-bold);
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: var(--ds-text-dim);
  margin: 0 0 var(--ds-s-5);
  text-align: center;
}

/* ============================================================
   GRID DE ATALHOS (3 cards)
   ============================================================ */
.caminhos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--ds-s-4);
  max-width: 680px;
  margin: 0 auto;
}

/* ============================================================
   CARD — base (mesmo padrão da LinkBio para manter consistência)
   ============================================================ */
.caminho-card {
  display: flex;
  align-items: center;
  gap: var(--ds-s-4);
  text-align: left;
  background: var(--ds-surface-2);
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-r-lg);
  padding: 22px;
  text-decoration: none;
  color: var(--ds-text);
  transition: all var(--ds-t-smooth);
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.caminho-card::before {
  content: '';
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity var(--ds-t-base);
  pointer-events: none;
}

.caminho-card:hover::before { opacity: 1; }

.caminho-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--ds-shadow-lg);
}

.caminho-home::before { background: linear-gradient(135deg, rgba(20, 203, 240, 0.14), transparent 60%); }
.caminho-wpp::before  { background: linear-gradient(135deg, rgba(37, 211, 102, 0.14), transparent 60%); }

.caminho-home:hover { border-color: rgba(20, 203, 240, 0.45); }
.caminho-wpp:hover  { border-color: rgba(37, 211, 102, 0.5); }

/* ============================================================
   ÍCONE
   ============================================================ */
.caminho-icone {
  min-width: 56px;
  height: 56px;
  border-radius: var(--ds-r-md);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  color: #fff;
}

.icone-home {
  background: linear-gradient(135deg, #14cbf0, #0fa7c5);
  box-shadow: 0 10px 28px -6px rgba(20, 203, 240, 0.45);
}

.icone-wpp {
  background: var(--ds-gradient-success);
  box-shadow: var(--ds-shadow-glow-success);
}

/* ============================================================
   CONTEÚDO CENTRAL
   ============================================================ */
.caminho-conteudo {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2px;
  position: relative;
  z-index: 1;
  min-width: 0;
}

.caminho-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: var(--ds-text-dim);
  font-family: var(--ds-font-bold);
}

.caminho-titulo {
  font-family: var(--ds-font-bold);
  font-size: 17px;
  color: var(--ds-text);
  line-height: 1.25;
}

.caminho-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.45;
  margin-top: 2px;
}

/* ============================================================
   SETA
   ============================================================ */
.caminho-seta {
  color: var(--ds-text-faint);
  transition: all var(--ds-t-base);
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

.caminho-card:hover .caminho-seta {
  color: var(--ds-text);
  transform: translateX(4px);
}

/* ============================================================
   CÓDIGO TÉCNICO DO ERRO — rodapé sutil
   ============================================================ */
.erro-tecnico {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: var(--ds-s-7) auto 0;
  padding: 8px 14px;
  border: 1px solid var(--ds-border-subtle);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.02);
  color: var(--ds-text-faint);
  font-family: var(--ds-font-mono, ui-monospace, SFMono-Regular, Menlo, monospace);
  font-size: 11.5px;
  letter-spacing: 0.2px;
  width: fit-content;
  max-width: 100%;
}

.erro-tecnico svg { flex-shrink: 0; }

/* ============================================================
   RESPONSIVO
   ============================================================ */
@media (max-width: 720px) {
  .erro-numero { margin-bottom: var(--ds-s-6); gap: 6px; }

  .caminhos-grid {
    grid-template-columns: 1fr;
    gap: var(--ds-s-3);
  }

  .caminho-card { padding: 16px; gap: var(--ds-s-3); }
  .caminho-icone { min-width: 48px; height: 48px; }
  .caminho-titulo { font-size: 15px; }
  .caminho-desc { font-size: 12.5px; }
  .caminhos-pergunta { font-size: 12px; letter-spacing: 1.5px; }
  .erro-tecnico { font-size: 10.5px; padding: 7px 12px; }
}
</style>
